import {Component, FunctionComponent} from 'react';

export function withNewOldReports<OldProps, NewProps>(OldComponent: FunctionComponent<OldProps>, NewComponent: FunctionComponent<NewProps>) {
	if(process.env.useOldReports) {
		return OldComponent;
	} else {
		return NewComponent;
	}
}